interface DrawingToolbarProps {
  activeTool: string | null
  onSelectTool: (name: string) => void
  onDeleteSelected: () => void
  onClearAll: () => void
}

interface ToolButton {
  name: string
  label: string
  icon: JSX.Element
}

const TrendLineIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
    <line x1="3" y1="17" x2="17" y2="3" />
  </svg>
)

const HorizontalLineIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
    <line x1="2" y1="10" x2="18" y2="10" />
  </svg>
)

const RectangleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="3" y="5" width="14" height="10" rx="1" />
  </svg>
)

const FibIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
    <line x1="2" y1="4" x2="18" y2="4" />
    <line x1="2" y1="8.5" x2="18" y2="8.5" strokeDasharray="3 2" />
    <line x1="2" y1="12" x2="18" y2="12" strokeDasharray="3 2" />
    <line x1="2" y1="16" x2="18" y2="16" />
  </svg>
)

const RulerIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="3" y="5" width="14" height="10" rx="1" />
    <line x1="6" y1="5" x2="6" y2="8" />
    <line x1="10" y1="5" x2="10" y2="9" />
    <line x1="14" y1="5" x2="14" y2="8" />
  </svg>
)

const TrashIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M5 6h10l-1 11H6L5 6z" />
    <path d="M3 6h14" />
    <path d="M8 6V4h4v2" />
  </svg>
)

const EraserIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M7 17h10" />
    <path d="M3 13l4 4 8-8-4-4-8 8z" />
  </svg>
)

const tools: ToolButton[] = [
  { name: 'TrendLine', label: 'Trend Line', icon: <TrendLineIcon /> },
  { name: 'HorizontalLine', label: 'Horizontal Line', icon: <HorizontalLineIcon /> },
  { name: 'Rectangle', label: 'Rectangle', icon: <RectangleIcon /> },
  { name: 'FibRetracement', label: 'Fib Retracement', icon: <FibIcon /> },
  { name: 'PriceRange', label: 'Price Range', icon: <RulerIcon /> },
]

export function DrawingToolbar({ activeTool, onSelectTool, onDeleteSelected, onClearAll }: DrawingToolbarProps) {
  return (
    <div className="absolute left-2 top-1/2 -translate-y-1/2 z-10 flex flex-col gap-1 bg-chart-bg/90 border border-chart-grid rounded-lg p-1 backdrop-blur-sm">
      {tools.map((tool) => (
        <button
          key={tool.name}
          title={tool.label}
          onClick={() => onSelectTool(tool.name)}
          className={`w-8 h-8 flex items-center justify-center rounded transition-colors ${
            activeTool === tool.name
              ? 'bg-blue-600 text-white'
              : 'text-text-secondary hover:text-text-primary hover:bg-chart-grid/60'
          }`}
        >
          {tool.icon}
        </button>
      ))}

      <div className="h-px bg-chart-grid my-1" />

      <button
        title="Delete selected"
        onClick={onDeleteSelected}
        className="w-8 h-8 flex items-center justify-center rounded text-text-secondary hover:text-ask hover:bg-chart-grid/60 transition-colors"
      >
        <TrashIcon />
      </button>
      <button
        title="Clear all drawings"
        onClick={onClearAll}
        className="w-8 h-8 flex items-center justify-center rounded text-text-secondary hover:text-ask hover:bg-chart-grid/60 transition-colors"
      >
        <EraserIcon />
      </button>
    </div>
  )
}
